import React from "react";

import LandingPage from "@/pages/Landing/LandingPage";

export default function Layout(): React.JSX.Element {
  return <LandingPage />;
}
